import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import { useRevokeSecretMutation } from "src/services/organizations/commands/secrets";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../context";
import DialogContext from "../context";

type Props = {
	onIncorrectPassword: () => void;
};

export default function useRevokeSecret({ onIncorrectPassword }: Props) {
	const [isLoading, setIsLoading] = useState(false);
	const { state } = useContext(Context);
	const { onClose } = useContext(DialogContext);

	const { mutate } = useRevokeSecretMutation();
	const { translate } = useLocales();
	const org = useGetOrg();
	const queryClient = useQueryClient();

	const appId = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";

	const onRevokeSecret = (password: string) => {
		setIsLoading(true);
		mutate(
			{ orgId: org.id, appId, password, secretId: state.deleteSecretId },
			{
				onSuccess: () => {
					setIsLoading(false);
					queryClient.refetchQueries({ queryKey: ["apps", "secrets", appId] });
					SnackbarUtils.success(translate("app_secrets.secret_revoked_success"));
					onClose();
				},
				onError: ({ response }: any) => {
					setIsLoading(false);
					if (response?.data?.message === "incorrect_password") {
						onIncorrectPassword();
					} else {
						SnackbarUtils.error(translate("app_secrets.secret_revoked_error"));
					}
				}
			}
		);
	};

	return { onRevokeSecret, isLoading };
}
